import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({});

export default useStyles;
